import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import {
  FrontendPaidFeatureAlertComponent,
  FrontendPaidFeatureComponent,
} from './components';
import { IonicModule } from '@ionic/angular';

const COMPONENTS = [
  FrontendPaidFeatureAlertComponent,
  FrontendPaidFeatureComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  imports: [
    CommonModule,
    RouterLink,
    NgbAlertModule,
    IonicModule,
    RouterLink,
  ],
})
export class FrontendPaidFeatureModule { }
